import 'bobjoll/ts/library/polyfill.js';
// Framework
import 'BobjollPopover';
import 'BobjollTrigger';
import 'BobjollDropdown';

/**
 * User
 */
 import { parseUser } from 'Auth/helpers';
 import { q } from 'bobjoll/ts/library/dom';

// Dispath view
const view = document.body.dataset.hbsTemplate;

if (view) {
    const print = new CustomEvent('print', {
        detail: view,
    });

    window.dispatchEvent(print);
}

// Language selector
const language = document.getElementById('language') as HTMLSelectElement;

if (language) {
    language.addEventListener('change', () => window.location.replace(language.value));
}

 const sessionString = decodeURIComponent(
     document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*gr_session2\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')
 );
 const sessionData = parseUser(sessionString);
 const downloadCounter = q('#icons_downloaded_counters');

 if (downloadCounter && sessionData) {
    if (typeof sessionData.downloads !== 'undefined' && typeof sessionData.limit_downloads !== 'undefined') {
        downloadCounter.innerHTML = sessionData.downloads + '/' + sessionData.limit_downloads;
    }
}
